module.exports = __webpack_public_path__ + "img/20240417140647024w3w.7613b9bc.jpg";